// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cyber-security-tip {
    animation-duration: 260ms;
    animation-timing-function: ease-out;
}

.cyber-security-tip.from-right {
    animation-name: cyberSecurityTipFromRight;
}

.cyber-security-tip.from-left {
    animation-name: cyberSecurityTipFromLeft;
}

@keyframes cyberSecurityTipFromRight {
    from {
        opacity: 0;
        transform: translateX(24px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes cyberSecurityTipFromLeft {
    from {
        opacity: 0;
        transform: translateX(-24px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .cyber-security-tip {
        animation: none;
    }
}

.cyber-security-nav {
    background: none;
    border: none;
    padding: 2px 6px;
    line-height: 1;
    color: #adb5bd;
    cursor: pointer;
    transition: color 150ms ease-in-out;
}

.cyber-security-nav:hover,
.cyber-security-nav:focus-visible {
    color: #495057;
}

.cyber-security-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: none;
    padding: 0;
    cursor: pointer;
    background-color: #ced4da;
    transition: background-color 150ms ease-in-out;
}

.cyber-security-dot.active {
    background-color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/React/MainWindow/Content/Dashboard/CyberSecurityCard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".cyber-security-tip {\n    animation-duration: 260ms;\n    animation-timing-function: ease-out;\n}\n\n.cyber-security-tip.from-right {\n    animation-name: cyberSecurityTipFromRight;\n}\n\n.cyber-security-tip.from-left {\n    animation-name: cyberSecurityTipFromLeft;\n}\n\n@keyframes cyberSecurityTipFromRight {\n    from {\n        opacity: 0;\n        transform: translateX(24px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes cyberSecurityTipFromLeft {\n    from {\n        opacity: 0;\n        transform: translateX(-24px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .cyber-security-tip {\n        animation: none;\n    }\n}\n\n.cyber-security-nav {\n    background: none;\n    border: none;\n    padding: 2px 6px;\n    line-height: 1;\n    color: #adb5bd;\n    cursor: pointer;\n    transition: color 150ms ease-in-out;\n}\n\n.cyber-security-nav:hover,\n.cyber-security-nav:focus-visible {\n    color: #495057;\n}\n\n.cyber-security-dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    background-color: #ced4da;\n    transition: background-color 150ms ease-in-out;\n}\n\n.cyber-security-dot.active {\n    background-color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
